import { ReactNode, useCallback, useState } from 'react';
import { useMapViewport } from '../modules/Settings/MapViewportContext';
import { ViewMode, DetailView, ViewModeContext } from '@ais-ui/custom-hooks';

// Re-export from shared lib for backward compatibility
export { ViewMode, DetailView, useViewMode } from '@ais-ui/custom-hooks';

interface ViewModeProviderProps {
  children: ReactNode;
}

export const ViewModeProvider = ({ children }: ViewModeProviderProps) => {
  const [viewMode, _setViewMode] = useState<ViewMode>(ViewMode.Normal);
  const [detailView, setDetailView] = useState<DetailView | null>(null);
  const { saveMapState } = useMapViewport();

  const setViewMode = useCallback(
    (newViewMode: ViewMode, subCategory: DetailView | null = null) => {
      _setViewMode(newViewMode);
      if (newViewMode === ViewMode.Detail) {
        // Save the current map state before switching to detail view, so that when the user returns to the map, it can restore the state
        saveMapState();
        setDetailView(subCategory);
      } else {
        setDetailView(null);
      }
    },
    [saveMapState],
  );

  const value = {
    viewMode,
    setViewMode,
    detailView,
  };

  return (
    <ViewModeContext.Provider value={value}>
      {children}
    </ViewModeContext.Provider>
  );
};
